import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: 'input[type="number"]'
})
export class PreventScrollDirective {

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault(); // Previene el cambio de valor
        }
    }

    @HostListener('wheel', ['$event'])
    onWheel(event: WheelEvent): void {
        event.preventDefault();
    }

    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent): void {
        const invalidChars = [',', '.', '+', '-', '/', '*'];
        if (invalidChars.includes(event.key)) {
            event.preventDefault(); // Previene la entrada de caracteres no permitidos
        }
    }
}
